import { apiFetch } from './client';

// Notification mirrors the API shape returned by GET /organizations/{slug}/notifications.
// Drives the bell dropdown in the top-right corner of the DashboardShell.
//
// `kind` is a stable identifier — i18n keys derive from it as
// notifications.kind.<kind>.title / .body. The server pre-renders title/body
// in the org's language as a fallback so unknown kinds still show something
// sensible.

export type NotificationSeverity = 'info' | 'success' | 'warning' | 'error';

export interface Notification {
  id: string;
  kind: string;
  severity: NotificationSeverity;
  title: string;
  body?: string;
  action_url?: string;
  metadata?: unknown;
  audit_log_id?: string;
  read_at?: string;
  created_at: string;
}

export interface ListNotificationsResponse {
  items: Notification[];
  total: number;
  unread: number;
}

interface ListOpts {
  limit?: number;
  unreadOnly?: boolean;
}

export async function listNotifications(
  token: string | null,
  slug: string,
  opts: ListOpts = {},
): Promise<ListNotificationsResponse> {
  const qs = new URLSearchParams();
  if (opts.limit) qs.set('limit', String(opts.limit));
  if (opts.unreadOnly) qs.set('unread', 'true');
  const query = qs.toString();
  const path = `/api/v1/organizations/${encodeURIComponent(slug)}/notifications${query ? `?${query}` : ''}`;
  return apiFetch<ListNotificationsResponse>(path, { token });
}

export async function markNotificationsRead(
  token: string | null,
  slug: string,
  ids: string[],
): Promise<void> {
  if (ids.length === 0) return;
  await apiFetch<void>(
    `/api/v1/organizations/${encodeURIComponent(slug)}/notifications/mark-read`,
    { method: 'POST', body: { ids }, token },
  );
}

export async function markAllNotificationsRead(
  token: string | null,
  slug: string,
): Promise<void> {
  await apiFetch<void>(
    `/api/v1/organizations/${encodeURIComponent(slug)}/notifications/mark-all-read`,
    { method: 'POST', body: {}, token },
  );
}
